<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 采购审批节点设置
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-form ref="workflowCompany" :inline="true" :model="workflowCompany">
        <el-form-item label="审批流程名称：" prop="workflowDefinitionName">
          <p>{{ workflowCompany.workflowDefinitionName }}</p>
        </el-form-item>
        <el-form-item label="审批节点信息：" prop="index">
          <p>第{{ workflowCompany.index }}审批节点</p>
        </el-form-item>
      </el-form>

      <!--表单添加-->
      <el-button
        type="primary"
        style="margin-bottom: 20px; float: right"
        @click="handleAddApprover"
        >新增审批人</el-button
      >
      <TableList
        :table-data="approverTableData"
        :index-show="true"
        :table-label="tableLabel"
      >
        <template #operation="slot">
          <el-button @click="handleDelete(slot.scope.$index)">删除</el-button>
        </template>
      </TableList>
      <edit-add-approver-dialog
        v-if="editAddApproverDialogShow"
        :visible="editAddApproverDialogShow"
        :dialog-title="dialogTitle"
        :approver-table-data="approverData"
        @close="closeApproverDialog"
        @getData="getData"
      ></edit-add-approver-dialog>

      <div style="margin-top: 20px; text-align: center">
        <el-button type="primary" @click="handleConfirm">确定添加</el-button>
        <el-button @click="handleCancle">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import EditAddApproverDialog from '../../components/company/editAddApproverDialog';

export default {
  name: '',
  components: {
    EditAddApproverDialog,
    TableList,
  },
  props: {},
  data() {
    return {
      input: '',
      workflowCompany: {
        workflowDefinitionName: '',
        index: '',
      },
      approverTableData: [],
      approverData: [],
      tableLabel: [
        {
          label: '审批人',
          param: 'realName',
          align: 'center',
        },
        {
          label: '登录名',
          param: 'memberName',
          align: 'center',
        },
        // {
        //   label: "所属部门",
        //   param: "",
        //   align: "center",
        // },
        {
          label: '联系方式',
          param: 'mobile',
          align: 'center',
        },
        { label: '操作', align: 'center', fixed: 'right', slot: 'operation' },
      ],
      editAddApproverDialogShow: false,
      dialogTitle: '',
      addApproverList: [],
    };
  },
  created() {
    this.workflowCompany.workflowDefinitionName = this.$getStore(
      'editWorkflowDefinitionName'
    );
    this.workflowCompany.index = this.$getStore('editIndex');
    this.getData();
  },
  methods: {
    // 新增审批人
    handleAddApprover() {
      this.editAddApproverDialogShow = true;
      this.approverData = this.approverTableData;
      this.dialogTitle = '新增审批人';
    },
    closeApproverDialog() {
      this.editAddApproverDialogShow = false;
    },
    getData(val) {
      val
        ? (this.addApproverList = val.approverList)
        : (this.addApproverList = []);
      const confirmWorkFlowSkusList = this.$getStore(
        'editConfirmWorkFlowSkusList'
      )
        ? JSON.parse(this.$getStore('editConfirmWorkFlowSkusList'))
        : null;
      let resData = [];
      let workFlowSkusList = null;
      if (val) {
        workFlowSkusList = val;
      } else if (this.$getStore('editWorkFlowSkusList') != 'undefined') {
        workFlowSkusList = JSON.parse(this.$getStore('editWorkFlowSkusList'));
      }
      if (
        workFlowSkusList != null &&
        workFlowSkusList.approverList.length > 0
      ) {
        this.approverTableData = workFlowSkusList.approverList;
        return;
      }

      if (confirmWorkFlowSkusList) {
        for (let i = 0; i < confirmWorkFlowSkusList.length; i++) {
          if (
            this.workflowCompany.workflowDefinitionName ==
              confirmWorkFlowSkusList[i].workflowDefinitionName &&
            parseInt(confirmWorkFlowSkusList[i].level) ==
              parseInt(this.workflowCompany.index)
          ) {
            resData = resData.concat(confirmWorkFlowSkusList[i].approverList);

            if (resData.length > 0) {
              const params = {
                workflowDefinitionName: this.$getStore(
                  'editWorkflowDefinitionName'
                ),
                level: this.$getStore('editIndex'),
                approverList: resData,
              };
              this.$setStore('editWorkFlowSkusList', params);
            }
            break;
          }
        }
      }
      if (this.approverTableData.length == 0) {
        if (this.$getStore('editWorkFlowSkusList') != 'undefined') {
          this.approverTableData = JSON.parse(
            this.$getStore('editConfirmWorkFlowSkusList')
          )[0].approverList;
        } else {
          this.approverTableData = [];
        }
      }
    },
    handleDelete(val) {
      this.approverTableData[val].isApprover = false;
      this.approverTableData.splice(val, 1);

      const workFlowSkusList = JSON.parse(
        this.$getStore('editWorkFlowSkusList')
      );
      if (workFlowSkusList != null) {
        workFlowSkusList.approverList = this.approverTableData;
      }
      this.$setStore('editWorkFlowSkusList', workFlowSkusList);
    },
    handleConfirm() {
      let confirmWorkFlowSkusList = JSON.parse(
        this.$getStore('editConfirmWorkFlowSkusList')
      );
      let workFlowSkusList = null;
      if (
        this.$getStore('editWorkFlowSkusList') == 'undefined' ||
        (this.addApproverList.length == 0 && this.approverTableData.length == 0)
      ) {
        return this.$message.warning('请添加审批人，请查看！');
      }
      workFlowSkusList = JSON.parse(this.$getStore('editWorkFlowSkusList'));

      if (
        workFlowSkusList != null &&
        parseInt(workFlowSkusList.level) ==
          parseInt(this.workflowCompany.index) &&
        workFlowSkusList.workflowDefinitionName ==
          this.workflowCompany.workflowDefinitionName
      ) {
        if (confirmWorkFlowSkusList == null) {
          confirmWorkFlowSkusList = [];
          confirmWorkFlowSkusList.push(workFlowSkusList);
        } else {
          let flag = false;
          confirmWorkFlowSkusList.forEach((sku) => {
            if (
              parseInt(workFlowSkusList.level) == parseInt(sku.level) &&
              workFlowSkusList.workflowDefinitionName ==
                sku.workflowDefinitionName
            ) {
              flag = true;
              sku.approverList = workFlowSkusList.approverList;
            }
          });
          if (flag == false) {
            confirmWorkFlowSkusList.push(workFlowSkusList);
          }
        }
      }
      if (confirmWorkFlowSkusList[0].approverList.length == 0) {
        return this.$message.warning('请添加审批人，请查看！');
      }
      this.$setStore('editConfirmWorkFlowSkusList', confirmWorkFlowSkusList);

      this.removeStore();
      this.goToUrl('/editPurchaseAudit', {
        name: confirmWorkFlowSkusList[0].workflowDefinitionName,
        path: 'editApproverEdit',
      });
    },
    handleCancle() {
      const obj = JSON.parse(this.$getStore('editConfirmWorkFlowSkusList'))[
        Number(this.workflowCompany.index) - 1
      ];
      this.$setStore('editWorkFlowSkusList', obj);
      this.$router.push({
        name: 'editPurchaseAudit',
        params: {
          path: 'editApproverEdit',
          workflowDefinitionName: this.workflowCompany.workflowDefinitionName,
        },
      });
    },
    goToUrl(url, params) {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.push({ path: url, query: params });
    },
    removeStore() {
      this.$setStore('editWorkFlowSkusList', null);
      this.$setStore('editIndex', null);
    },
  },
};
</script>

<style scoped></style>
